/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

export const DELETE_ACTION_GROUP = gql`
  mutation DeleteActionGroup($input: DeleteObjectInput!) {
    deleteActionGroup(data: $input) {
      id
    }
  }
`
